const numberEnv = (value: string | undefined, fallback: number) => {
  const parsed = Number(value)
  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback
}

export const config = {
  appName: import.meta.env.VITE_APP_NAME || 'Asistencias HILTAC',
  publicUrl: import.meta.env.VITE_PUBLIC_URL || window.location.origin,
  apiUrl: import.meta.env.VITE_APPS_SCRIPT_API_URL || '',
  googleClientId: import.meta.env.VITE_GOOGLE_CLIENT_ID || '',
  mode: import.meta.env.VITE_DATA_MODE === 'supabase' ? 'supabase' : import.meta.env.VITE_DATA_MODE === 'google' ? 'google' : 'mock',
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL || '',
  supabaseAnonKey: import.meta.env.VITE_SUPABASE_ANON_KEY || '',
  displayLinkTtlSeconds: numberEnv(import.meta.env.VITE_DISPLAY_LINK_TTL_SECONDS, 60),
} as const
